import { Button, Form, InputItem, TextareaItem } from 'dingtalk-design-mobile';
import './AdviceForm.less'
import { RightArrow2Outlined } from 'dd-icons';
import useHistory from '@/hooks/useHistory'
import { useEffect, useState } from 'react';
import { _adviceFromApply, _getHistoryAdviceList } from '@/api/user'
import { htmlEncode } from '@/utils/tool';
import { useNavigate } from 'react-router-dom'

const AdviceForm = () => {
  const history = useHistory()
  const navigate = useNavigate()
  
  const goHistory = () => {
    history.push('/AdviceHistory', 'route')
  }
  const [formValue, setFormValue] = useState({
    name: '',
    mobile: '',
    address: '',
    title: '',
    content: ''
  })

  const [hasHistory, setHasHistory] = useState(false)

  const getHistoryList = () => {
    _getHistoryAdviceList().then(res => {
      const [d, result] = res
      if (d && result && result.length > 0) {
        setHasHistory(true)
      }
    })
  }
  const onFinish = (res) => {
    // console.log(res)
    const params = {
      ...res,
      content: htmlEncode(res.content),
      address: htmlEncode(res.address)
    }
    
    _adviceFromApply(params).then(res => {
      const [d, result] = res
      console.log(result)
      if (d && result) {
        setTimeout(() => {
          history.push('/SubmitStatus?id=' + result, 'route')
        }, 1000)
      }
    })
  }

  useEffect(() => {
    getHistoryList()
  }, [])

  const validateMobile =  (_rule, value) => {
    const PhoneReg = /^(?:(?:\+|00)86)?1(?:(?:3[\d])|(?:4[5-7|9])|(?:5[0-3|5-9])|(?:6[5-7])|(?:7[0-8])|(?:8[\d])|(?:9[1|8|9]))\d{8}$/
    if (!value) {
      return Promise.reject(new Error('请输入手机号!'))
    }
    return PhoneReg.test(value) ? Promise.resolve() : Promise.reject(new Error('请输入正确的手机号!'))
  }

  return (
    <div className="pg-advice-form">
      <img className='header' src='https://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/advice/advice-header.png' />
      <div className="pg-advice-form--wrap">
        {
          hasHistory &&
          <div className='history-row' onClick={goHistory}>
            历史记录 
            <RightArrow2Outlined />
          </div>
        }
        <Form 
          initialValues={formValue} 
          onFinish={onFinish}
        >
          <div className='person-info card'>
            <img className='icon' src='https://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/advice/person-info.png' />
            <Form.Item label="姓名" name="name" rules={[{ required: true, message: '请输入姓名' }]}>
              <InputItem placeholder="请输入" maxLength={10} />
            </Form.Item>
            <Form.Item label="手机号" name="mobile" rules={[{ required: true, validator: validateMobile }]}>
              <InputItem placeholder="请输入" inputMode='tel' />
            </Form.Item>
            <Form.Item label="联系地址" name="address" position="brief">
              <TextareaItem rows={2} placeholder="请输入" count={50} />
            </Form.Item>
          </div>
          <div className='apply-info card'>
            <img className='icon' src='https://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/advice/event-info.png' />
            <Form.Item label="标题" name="title" rules={[{ required: true, message: '请输入标题' }]}>
              <InputItem placeholder="请输入，不超过30个字" maxLength={30} />
            </Form.Item>
            <Form.Item label="反馈内容" name="content" position="brief" rules={[{ required: true, message: '请输入反馈内容' }]}>
              <TextareaItem rows={5} placeholder="诉求：反映事项的主要事实（某月某日，发生什么事情…），理由与依据…具体要求…" count={300} />
            </Form.Item>
            <div className='form-btn'>
              <Button className='btn' htmlType="submit">提交</Button>
            </div>
          </div>
        </Form>
      </div>
    </div>
  )
}

export default AdviceForm